import Vue from 'vue'

const bus = new Vue()

class EventBus {
  public install (Vue: any) {
    Vue.prototype.$eventBus = bus
  }
}

const eventBus = new EventBus()

export { eventBus, bus }
